<template>
  <div
    ref="slide"
    class="swiper-slide"
    @click="isActiveSlide ? toggleProducts($event) : null"
    :style="[isMobile && enableOnlyProductModalList ? { cursor: 'default' } : {}]"
  >
    <transition name="fade">
      <img v-show="loaded" ref="carouselImage" class="swiper-lazy" :data-src="item.imageUrl + '?h=0.5&q=40'" @load="imageLoaded" />
    </transition>

    <div v-if="loaded && (!isMobile || enableImageTagging)" class="tag-wrapper">
      <div v-for="(product, index) in item.products" :key="index" class="tag-wrapper">
        <ProductImageTag
          v-if="product.coordinates.length > 0 && product.coordinates[0].x !== null && product.coordinates[0].y !== null"
          :isActiveSlide="isActiveSlide"
          :tracking="tracking"
          :is-mobile="isMobile"
          :isTagVisible="tagsVisible"
          :tagsEnabled="tagsEnabled"
          :naturals="$refs.carouselImage"
          :product="{ id: product.id, x: product.coordinates[0].x, y: product.coordinates[0].y }"
          :direction="directions[product.coordinates[0].sort]"
        />
      </div>
    </div>

    <transition name="fade">
      <template v-if="loaded && isMobile && !disableImageTaggingAndModal">
        <transition name="fade">
          <div class="show-products" @click="openModal($event)">
            <button class="show-products-btn">
              <ShoppingBag class="shopping-bag-icon" />
              <span>Product List</span>
            </button>
          </div>
        </transition>
      </template>
      <template v-else-if="loaded">
        <transition name="fade">
          <div class="show-products show-products-control">
            <button v-if="isActiveSlide" ref="showButton" class="show-products-btn">
              <span v-if="tagsVisible || showProductTiles" :class="widgetState">Hide Products</span>
              <span v-else :class="widgetState">Show Products</span>

              <ShoppingBag v-if="tagsVisible || $parent.showProductTiles" class="shopping-bag-icon" />
              <ShoppingBag v-else class="shopping-bag-icon" />
            </button>
          </div>
        </transition>
      </template>
    </transition>
  </div>
</template>

<script>
import smoothReflow from '@/plugins/smoothReflow';
import { MediaUtils } from '@/pixel/index';
import ShoppingBag from '@/assets/ShopBy/shopping-bag.svg';
import ProductImageTag from './ProductImageTag.vue';
import LocalStorage, { LocalStorageKeys } from '@/components/commons/LocalStorage.js';
import { nextTick } from 'vue';
import { getImageTaggingTestVariant } from '@/components/commons/utils.js';
import useHome from '@/compositions/useHome';

export default {
  name: 'GallerySlide',
  components: {
    ShoppingBag,
    ProductImageTag,
  },
  mixins: [smoothReflow],

  props: {
    item: Object,
    isActiveSlide: Boolean,
    tracking: Object,
    index: Number,
    isMobile: {
      type: Boolean,
      default: false,
    },
    turnOffAllExperiments: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      get widgetState() {
        return LocalStorage.get(LocalStorageKeys.ROOM_IDEAS_WIDGET_STATE);
      },
      directions: ['top', 'right', 'bottom', 'left'],
      showProductTiles: false,
      tagsVisible: false,
      loaded: false,
      disableImageTaggingAndModal: getImageTaggingTestVariant() === 0 || this.turnOffAllExperiments,
      enableImageTagging: getImageTaggingTestVariant() === 1 && !this.turnOffAllExperiments,
      enableOnlyProductModalList: getImageTaggingTestVariant() === 2 && !this.turnOffAllExperiments,
    };
  },

  setup() {
    const { showModal, updateShowProductListModal } = useHome();

    let productTags = [];

    const setTag = (tag) => {
      productTags.push(tag);
    };

    return {
      showModal,
      updateShowProductListModal,
      productTags,
      setTag,
    };
  },

  computed: {
    tagsEnabled() {
      return !MediaUtils.isMobileAndSmaller;
    },
  },

  watch: {
    showModal(val) {
      if (val) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'initial';
      }
    },

    isActiveSlide(val) {
      if (!val) {
        this.tagsVisible = false;
        if (this.showProductTiles) {
          this.$emit('toggleProductTiles');
        }
      }
    },
  },

  mounted() {
    // this.$smoothReflow({ property: ['width'] });
    window.addEventListener('resize', this.forceHideTags);
  },

  unmounted() {
    window.removeEventListener('resize', this.forceHideTags);
  },

  methods: {
    openModal(e) {
      this.updateShowProductListModal(true);
      e.stopPropagation();
    },
    forceHideTags() {
      this.tagsVisible = false;
    },

    toggleProductTiles() {
      if (!this.isActiveSlide) {
        return false;
      }
      this.showProductTiles = !this.showProductTiles;
      this.$emit('toggleProductTiles');
    },

    toggleProducts(event) {
      if (!this.isActiveSlide) {
        return;
      }
      if (MediaUtils.isMobileAndSmaller && (this.enableOnlyProductModalList || this.showModal)) {
        event.stopPropagation();
        return;
      }
      if (this.tagsEnabled || this.enableImageTagging) {
        this.toggleTags();
      } else {
        this.toggleProductTiles();
      }

      LocalStorage.set(LocalStorageKeys.ROOM_IDEAS_WIDGET_STATE, 'interacted');
    },

    toggleTags() {
      this.tagsVisible = !this.tagsVisible;
    },

    imageLoaded() {
      this.loaded = true;
      // nextTick(() => {
      //   if (MediaUtils.isMobileAndSmaller) {
      //     this.$smoothReflow({ el: '.show-products button, .show-products button span, .show-products button svg', property: ['width'] });
      //   } else {
      //     this.$smoothReflow({ el: '.show-products button span, .show-products button svg', property: ['width'] });
      //   }
      // });
    },
  },
};
</script>

<style lang="postcss" scoped>
@import '@/pixel/style/variables';

@keyframes GradFade {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 100% 50%;
  }
}

.swiper-slide {
  position: relative;
  z-index: 9;
  max-width: 100vw;
  width: auto;
  height: 100%;
  cursor: pointer;
  background: $white;
  z-index: -1;

  &.swiper-slide-active {
    z-index: 1;
  }

  &.loading {
    min-width: 700px;
    min-height: 100%;
    /* purgecss ignore */
    &:after {
      position: absolute;
      content: '';
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 4px;
      background: linear-gradient(74deg, var(--grey-ultra-light), white, var(--grey-ultra-light));
      background-size: 600% 600%;
      animation: GradFade 1.5s ease-in-out infinite;
    }
  }
}

.slide {
  position: relative;
}

.show-products {
  position: absolute;
  bottom: 0;
  left: 0;
  margin: 16px;
  cursor: pointer;
  z-index: 9;
  cursor: pointer;

  &.show-products-control {
    @media (max-width: calc($mobile-breakpoint - 1px)) {
      left: unset;
      right: 0;
    
      /* purgecss ignore */
      span:not(.hide-products):not(.uninteracted) {
        display: none;
      }
    }
  }

  span,
  svg {
    display: inline-block;
    line-height: 1;
    padding: 0;
    margin: 0;
    vertical-align: middle;
    white-space: nowrap;
  }

  svg {
    width: 20px;
    height: 20px;
    margin-top: -2px;
  }

  .show-products-btn {
    border: none;
    background: $white;
    pointer-events: none;
    span {
      color: var(--grey-medium);
    }
  }

  @media (max-width: $tablet-breakpoint) {
    .show-products-btn {
      border: none;
      background: $white;
      pointer-events: none;
    }
  }

  @media (max-width: calc($mobile-breakpoint - 1px)) {
    .show-products-btn {
      span {
        font-size: 14px;
      }
    }

    svg {
      transform: scale(1.55);
      width: 11px;
      height: 21px;
      margin-right: 5px;
    }
  }
}

@media (max-width: $mobile-breakpoint) {
  img {
    width: 100vw;
  }
}
@media (min-width: $mobile-breakpoint) {
  img {
    height: 350px;
    width: auto;
  }
}

@media (min-width: $tablet-breakpoint) {
  img {
    height: 450px;
    width: auto;
  }
}

@media (min-width: $desktop-breakpoint) {
  img {
    height: 600px;
    width: auto;
  }
}
</style>
